// extracted by mini-css-extract-plugin
export default {"container":"Tickets_container__w29TP","ticketsContainer":"Tickets_ticketsContainer__6OSsb","filters":"Tickets_filters__EBCqF","addButton":"Tickets_addButton__h1K1n"};